// extracted by mini-css-extract-plugin
export var fileUpload = "_d1-1";
export var modalButton = "_d1-0";